const style = {
  card: {
    mt: 3,
    p: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#F3F4F6',
    boxShadow: '0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)',
  },
  icon: {
    viewBox: '0 0 88 43',
    sx: {
      fontSize: 150,
    },
  },
} as const;

export default style;
